
















import { Vue, Component } from 'vue-property-decorator';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import PatternMakerView from '@/components/molecule.patternMaker.mainView.patternMaker.vue';
import patternMaker from '@/mixins/PatternMaker';

@Component({
  components: {
	CustomModal,
  PatternMakerView
  },
  mixins: [patternMaker]
})
export default class PatternMaker extends Vue {
  maxWidth: number = 800;
  beforeOpenModal() {}
  closeAction() {
    this.$modal.hide('patternMaker');
  }

}
